import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/soundOff.tsx
var SoundOff = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M5.76895 7.87879H2.95238C2.4264 7.87879 2 8.31294 2 8.84848V15.1515C2 15.6871 2.4264 16.1212 2.95238 16.1212H5.76895C5.95091 16.1212 6.12907 16.1743 6.28233 16.2742L12 20V4L6.28233 7.72584C6.12907 7.82571 5.95091 7.87879 5.76895 7.87879Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M22 9.5L19.5 12M19.5 12L17 14.5M19.5 12L17 9.5M19.5 12L22 14.5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round"
	})] }) : /* @__PURE__ */ jsx("path", {
		d: "M11.6797 3.32172C11.8937 3.22056 12.1457 3.22561 12.3574 3.34027C12.5991 3.47136 12.7499 3.72449 12.75 3.99945V19.9995C12.75 20.2745 12.5991 20.5275 12.3574 20.6586C12.1155 20.7897 11.8213 20.7776 11.5908 20.6274L5.87305 16.9018C5.84095 16.8809 5.80424 16.8705 5.76855 16.8705H2.95215C1.99942 16.8704 1.25007 16.0876 1.25 15.1508V8.84808C1.25021 7.91137 1.99951 7.12848 2.95215 7.12836H5.76855C5.80428 7.12836 5.84092 7.11802 5.87305 7.09711L11.5908 3.37152L11.6797 3.32172ZM21.5264 8.91742C21.8209 8.67714 22.2557 8.69461 22.5303 8.96918C22.8049 9.24377 22.8223 9.6785 22.582 9.97308L22.5303 10.0297L20.5605 11.9995L22.5303 13.9692L22.582 14.0258C22.8223 14.3204 22.8048 14.7551 22.5303 15.0297C22.2557 15.3043 21.8209 15.3218 21.5264 15.0815L21.4697 15.0297L19.5 13.06L17.5303 15.0297C17.2374 15.3226 16.7626 15.3226 16.4697 15.0297C16.1769 14.7368 16.1768 14.2621 16.4697 13.9692L18.4395 11.9995L16.4697 10.0297L16.418 9.97308C16.1777 9.6785 16.1951 9.24377 16.4697 8.96918C16.7443 8.69461 17.1791 8.67714 17.4736 8.91742L17.5303 8.96918L19.5 10.9389L21.4697 8.96918L21.5264 8.91742Z",
		fill: "currentColor"
	})
});
//#endregion
export { SoundOff };
